import React from "react";
import AddIcon from "@mui/icons-material/Add";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { Link } from "react-router-dom"; //Link
 
import m1 from "../assets/images/m1.png";
import m2 from "../assets/images/m2.png";
import m3 from "../assets/images/m3.png";
import m4 from "../assets/images/m4.png";

const medicines = [
  {
    id: 1,
    name: "Dolo 650 Tablet",
    category: "Medicine Tablet 1mg",
    price: 29.1,
    oldPrice: 999,
    discount: "25% Off",
    image: m1,
  },
  {
    id: 2,
    name: "Amoxiclav Dry Syrup With Water",
    category: "Dry Syrup",
    price: 35,
    oldPrice: 50,
    discount: "25% Off",
    image: m2,
  },
  {
    id: 3,
    name: "Pre & Pro Biotic Zinc Gluconate",
    category: "Dry Syrup",
    price: 70,
    oldPrice: 200,
    discount: "25% Off",
    image: m3,
  },
  {
    id: 4,
    name: "Cefuroxime Axetil Tablets",
    category: "Tablet",
    price: 2100,
    oldPrice: 2500,
    discount: "25% Off",
    image: m4,
  },
  {
    id: 5,
    name: "Cefuroxime Axetil Tablets",
    category: "Tablet",
    price: 2100,
    oldPrice: 2500,
    discount: "25% Off",
    image: m2,
  },
];

function OrderMedicine() {
  return (
    <div className="order-medicine-outer">
      <div className="container-fluid">
        <div className="row g-3">
          {medicines.map((medicine) => (
            <div className="col-xl-4 col-lg-6 col-md-4 col-sm-12 col-12">
              <div className="medicine-card">
                <button className="wishlist-btn">
                  <FavoriteBorderIcon />
                </button>

                <label className="discount-price">
                  {medicine.discount}
                </label>


                <div className="medicine-image">
                   <Link to="/product"><img src={medicine.image} alt={medicine.name} /></Link> 
                </div>

                <div className="medicine-content">
                  <h3> <Link to="/">{medicine.name}</Link></h3>

                  <p className="medicine-type">{medicine.category}</p>

                  <div className="price-divider"></div>

                  <div className="price-row">
                    <div className="medicine-price">
                      <span className="sale-price">₹{medicine.price}</span>

                      <span className="old-price">₹{medicine.oldPrice}</span>

                    </div>

                    <button className="medicine-add-btn">
                      <AddIcon /> Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OrderMedicine;
